<template>
    <v-container class="px-0 pb-0">
        <v-row class="align-center">
            <v-col cols="12" md="9" class="pr-0">
                <v-text-field
                    v-model="searchText"
                    :label="localize('searchByOrderNo')"
                    dense
                    outlined
                    hide-details
                    @keyup="searchOrder"
                >
                    <fa slot="append" :icon="['fal', 'search']" class="fa-lg" />
                </v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="pr-0">
                <v-select
                    v-model="orderFilter"
                    :items="filterList"
                    :label="localize('filterBy')"
                    dense
                    outlined
                    color="primary"
                    hide-details
                    @change="filterOrder"
                ></v-select>
            </v-col>
            <v-col
                v-if="selections.length > 0 && $vuetify.breakpoint.smAndDown"
                cols="12"
                md="8"
                class="py-0 pb-0 d-flex align-center"
            >
                <TranslatableStringComponent :tstring="{string: 'yourSelections'}" />: </v-col>
            <v-col
                v-if="selections.length > 0 "
                md="8"
                class="py-0 pb-0 d-flex align-center"
            >

                <TranslatableStringComponent v-if="!$vuetify.breakpoint.smAndDown" :tstring="{string: 'yourSelections'}" />
                <v-chip-group class="ml-2" column>
                    <div v-for="tag in selections" :key="tag.value">
                        <v-chip
                            v-if="tag.label.length"
                            color="primary"
                            outlined
                            :close="tag.close"
                            small
                            @click:close="closeChip(tag.value)"
                        >
                            <TranslatableStringComponent v-if="tag.value === 'orderFilter'" :tstring="{string: `${tag.label}`}" />
                            <span v-else>{{ tag.label }}</span>
                        </v-chip>
                    </div>
                </v-chip-group>
            </v-col>
            <v-col md="4" class="py-0 pb-2 d-flex justify-end">
                <v-btn
                    small
                    :text="!$vuetify.breakpoint.smAndDown"
                    :fab="$vuetify.breakpoint.smAndDown"
                    :outlined="$vuetify.breakpoint.smAndDown"
                    color="primary"
                    class="px-2"
                    @click="getfreshOrders()"
                >
                    <fa
                        v-if="$vuetify.breakpoint.smAndDown"
                        :icon="['fal', 'redo']"
                        class="fa-md" 
                        style="color: primary" 
                        />
                    <TranslatableStringComponent v-if="!$vuetify.breakpoint.smAndDown" :tstring="{string: 'refreshData'}" />
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'SearchOrders',
    components: { TranslatableStringComponent },
    props: {},
    data() {
        return {
            dateSort: ['Latest', 'Oldest'],
            sortOrdersByDate: 'Latest',
            filterList: [
                {text: this.localize('inProgressOrders'), value: 'In progress orders'},
                {text: this.localize('completedOrders'), value: 'Completed orders'},
                {text: this.localize('recentOrders'), value: 'Recent orders'},
            ],
            orderFilter: 'Recent orders',
            searchText: undefined,
            selections: [{
                label: 'recentOrders',
                value: 'orderFilter',
                close: false
            }],
        }
    },
    methods: {
        getfreshOrders() {
            this.$emit('getfreshOrders', this.orderFilter)
        },
        filterOrder() {
            this.selections = this.selections.find(
                (i) => i.value === 'orderFilter'
            )
                ? this.selections.filter((i) => i.value !== 'orderFilter')
                : this.selections
            this.selections.push({
                label: this.orderFilter === 'Recent orders' ? 'recentOrders' : this.orderFilter === 'In progress orders' ?  'inProgressOrders' : 'completedOrders',
                value: 'orderFilter',
                close: false
            })
            this.$emit('filterOrders', this.orderFilter)
        },
        searchOrder() {
            this.selections = this.selections.find(
                (i) => i.value === 'searchText'
            )
                ? this.selections.filter((i) => i.value !== 'searchText')
                : this.selections
            this.searchText = this.searchText?.trim() // BUG FIXED: without optional chaining typing a space in the input would throw error
            if (this.searchText.length > 0) {
                this.selections.push({
                    label: this.searchText,
                    value: 'searchText',
                    close: true
                })
            }
            this.$emit('searchOrder', this.searchText, this.orderFilter)
        },
        closeChip(value) {
            this.selections = this.selections.filter((i) => i.value !== value)
            switch (value) {
                case 'orderFilter':
                    {
                        this.orderFilter = 'Recent orders'
                        this.$emit('filterOrders', this.orderFilter)
                    }
                    break
                case 'searchText':
                    {
                        this.searchText = undefined
                        this.$emit(
                            'searchOrder',
                            this.searchText,
                            this.orderFilter
                        )
                    }
                    break
            }
        },
    },
}
</script>
